var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["readPackageSync"]: () => __WEBPACK_EXTERNAL_MODULE_read_pkg_216bd93d__.readPackageSync });